<template lang="html">
  <section class="take-place column">
		<div class="no-estate white-box column" v-if="!isEstate">
			<img src="@/assets/img/folder.svg" alt="">
			<div class="title bold"> Pas encore assez de données </div>
			<div class="text">
				Nous ne disposons pas d'assez de données <br/> Commencez par remplir votre paysage patrimonial
			</div>
			<router-link class="btn btn-red" :to="{ name: 'PatrimonialLandscape' }">
				Renseigner mon Paysage Patirmonial
			</router-link>
		</div>
		<div class="take-place from-start column" v-else>
			<div class="master-investments large">
				<div class="group">
					<div class="title">
						Historique
					</div>
					<div class="section-table column">
						<div class="header-array row">
							<div class="header-col row" v-for="(col, key) in colDefs" :style="{ width: col.width + '%' }" v-bind:key="key" @click="setFilter(key)">
								{{ col.name }}
								<span class="arrow" :class="{down: isFiltered(key)}"></span>
							</div>
							<div class="deploy"></div>
						</div>
						<div class="body-array column">
							<div class="body-row column" v-for="(row, key) in computedRows" v-bind:key="row.key">
								<div class="inner-row row">
									<div class="body-cell" :class="colDefs[keyt].style" v-for="(cell, keyt) in row.data" :style="{ width: colDefs[keyt].width + '%'}" v-bind:key="keyt">
										{{ cell }}
									</div>
									<div class="deploy row" @click="deployRow(row.key)" :class="{ active: rowDefs[key].deploy }">
										<span class="icon-arrow-full-down"></span>
									</div>
								</div>
								<div class="row-child" :class="{ active: rowDefs[key].deploy }">
									<div class="header-child row">
										<div class="header-col bold" v-for="(col, keyt) in childDefs" :style="{ width: col.width + '%' }" v-bind:key="keyt">
											{{ col.name }}
										</div>
									</div>
									<div class="body-child column">
										<div class="row-body-child row" v-for="(row, keyg) in rowDefs[key].childs" v-bind:key="keyg">
											<div class="cell-child" v-for="(cell, keyd) in row" v-bind:key="keyd" :style="{ width: childDefs[keyd].width + '%' }">
												{{ cell }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import SectionTable from '@/common/components/section-table'

export default {
	components: {
		SectionTable
	},
	data () {
		return {
			colDefs: [
				{ name: 'contrat', width: 20 },
				{ name: 'opérations', width: 20, style: 'bold' },
				{ name: 'type', width: 15 },
				{ name: 'date de signature', width: 20 },
				{ name: 'montant', width: 20 }
			],
			childDefs: [
				{ name: 'supports', width: 20 },
				{ name: 'nb de part', width: 20 },
				{ name: 'valeurs unitaire', width: 15 },
				{ name: 'poids', width: 20 },
				{ name: 'valeurs', width: 20 }
			],
			rowDefs: [
				{
					key: 0,
					data: ['821821821', 'MISSION #6 - Retraite', 'Financier', '14 Mars 2018', '67 675.23€'],
					childs: [
						['CRCAM BRIE PIC2CCI', '200', '150,44', '40%', '30 088.24 €'],
						['BNP PARIBAS BR-A', '400', '150,44', '60%', '19 305.24 €']
					],
					deploy: false
				},
				{
					key: 1,
					data: ['588888589', 'MISSION #5 - Assurance Vie', 'Tangible', '15 Août 2018', '150 000.00€'],
					childs: [
						['CRAMME BRIE PIC2CCI', '200', '150,44', '40%', '30 088.24 €']
					],
					deploy: false
				}
			],
			filter: {
				key: null,
				asc: true
			}
		}
	},
	methods: {
		deployRow (key) {
			this.rowDefs.forEach((row) => {
				if (row.key === key) row.deploy = !row.deploy
			})
		},
		setFilter (key) {
			if (this.filter.key === key) {
				this.filter.asc = !this.filter.asc
			} else {
				this.filter = {
					key: key,
					asc: true
				}
			}
		},
		isFiltered (key) {
			return (key === this.filter.key) ? this.filter.asc : false
		}
	},
	computed: {
		...mapGetters({
			isEstate: 'isEstate'
		}),
		computedRows () {
			let result = this.rowDefs
			if (this.filter.key !== null) {
				result = result.sort((a, b) => {
					const value = (this.filter.asc) ? (a.data[this.filter.key] > b.data[this.filter.key]) : (a.data[this.filter.key] < b.data[this.filter.key])
					return (value) ? 1 : -1
				})
			}
			return result
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/views/Investments/History.vue